angular
    .module('BBPublicBooking')
    .factory('PurchaseService', ($q, halClient, BBModel) => {

        return {

            doPurchaseAPIAction(action, url, params, defer) {
                halClient[action](url, params)
                    .then((purchase) => {
                        this.buildPurchaseTotalModels(purchase, defer);
                    })
                    .catch(err => defer.reject(err));
            },

            buildPurchaseTotalModels(purchase, defer) {
                const purchaseTotalModel = new BBModel.Purchase.Total(purchase);
                purchaseTotalModel.getPurchaseData()
                    .then(purchaseTotal =>  defer.resolve(purchaseTotal))
                    .catch(err => defer.reject(err));
            },

            query(params) {
                const defer = $q.defer();
                const uri = `${params.url_root}/api/v1/purchases/${params.purchase_id}`;
                this.doPurchaseAPIAction('$get', uri, params, defer);
                return defer.promise;
            },

            bookingRefQuery(params) {
                const defer = $q.defer();
                const uri = `${params.url_root}/api/v1/purchases/booking_ref/${booking_ref}`;
                this.doPurchaseAPIAction('$get', uri, params, defer);
                return defer.promise;
            },

            update(params) {
                let booking;
                const defer = $q.defer();
                const data = {};

                if (!params.purchase) {
                    defer.reject('No purchase present');
                    return defer.promise;
                }

                if (params.bookings) {
                    const bookingData = [];
                    for (booking of Array.from(params.bookings)) {
                        bookingData.push(booking.getPostData());
                    }
                    data.bookings = bookingData;
                }

                if (params.move_reason) {
                    for (booking of Array.from(data.bookings)) {
                        booking.move_reason = params.move_reason;
                    }
                }

                params.purchase.$put('self', {}, data)
                    .then(purchase => this.buildPurchaseTotalModels(purchase, defer))
                    .catch(err => defer.reject(err));

                return defer.promise;
            },

            bookWaitlistItem(params) {
                const defer = $q.defer();
                const data = {
                    booking_id: params.booking.id
                };

                if (!params.purchase && !params.purchase_id) {
                    defer.reject('No purchase or purchase_id present');
                }

                if (params.purchase) {
                    params.purchase.$put('book_waitlist_item', {}, data)
                        .then(purchase => this.buildPurchaseTotalModels(purchase, defer))
                        .catch(err => defer.reject(err));

                } else if (params.purchase_id && params.url_root) {
                    const uri = `${params.url_root}/api/v1/purchases/${params.purchase_id}/book_waitlist_item`;
                    this.doPurchaseAPIAction('$put', uri, params, defer);
                }

                return defer.promise;
            },

            deleteAll(purchase) {
                const defer = $q.defer();

                if (!purchase) {
                    defer.reject('No purchase present');
                    return defer.promise;
                }

                purchase.$del('self')
                    .then(purchase => this.buildPurchaseTotalModels(purchase, defer))
                    .catch(err => defer.reject(err));

                return defer.promise;
            },

            deleteItem(params) {
                const defer = $q.defer();
                const uri = `${params.api_url}/api/v1/purchases/${params.long_id}/purchase_item/${params.purchase_item_id}`;
                this.doPurchaseAPIAction('$del', uri, params, defer);
                return defer.promise;
            }
        };
    }
);




// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/public-booking/purchase/_services/purchase.service.js